import { render, staticRenderFns } from "./ORTCreate.vue?vue&type=template&id=15f95285&scoped=true"
import script from "./ORTCreate.vue?vue&type=script&lang=js"
export * from "./ORTCreate.vue?vue&type=script&lang=js"
import style0 from "./ORTCreate.vue?vue&type=style&index=0&id=15f95285&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f95285",
  null
  
)

export default component.exports